export const dateFormatDay = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
};

export const dateFormatStart = (date = new Date()) => {
  let currentDate = date ? new Date(date) : new Date();

  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");

  const formattedDate = `${year}-${month}-${day} 00:00`;
  return formattedDate;
};

export const dateFormatEnd = (date = new Date()) => {
  let currentDate = date ? new Date(date) : new Date();

  currentDate.setDate(currentDate.getDate() + 1);

  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");

  const formattedDate = `${year}-${month}-${day} 00:00`;
  return formattedDate;
};

export const dateFormatPlusMonth = (date = new Date()) => {
  let currentDate = date ? new Date(date) : new Date();

  // 현재 날짜의 월을 +2로 변경
  currentDate.setMonth(currentDate.getMonth() + 1);

  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");

  const formattedDate = `${year}-${month}-${day} 00:00`;
  return formattedDate;
};
